module.exports = {
	"1-seedling" : require("./1-seedling"),
	"2-fungus" : require("./2-fungus")
}